
export const trouverNoeud = (noeud, idCible) => {
  if (noeud == null) {
    return null
  }

  const trouveDansLesFils = (noeud.typeCultureFils || [])
    .map((fils) => trouverNoeud(fils, idCible))
    .find((resultat) => resultat !== null)

  if (trouveDansLesFils !== undefined) {
    return trouveDansLesFils
  }
  if (noeud.id === idCible) {
    return noeud
  }
  return null
}

export const formaterNoeud = (noeud, hauteur = 0) => {
  if (noeud == null) {
    return null
  }

  const noeudFormate = {
    id: noeud.id,
    label: noeud.nom,
    isDisabled: noeud.isDisabled,
    hauteur
  }

  const enfants = (noeud.typeCultureFils || []).map((fils) => formaterNoeud(fils, hauteur + 1))
  if (enfants.length) {
    noeudFormate.children = enfants
  }
  return noeudFormate
}
